import React, { useState } from "react";
import { ChartLine, Presentation, ChartBar, Search, Compass, ArrowRight, TrendingUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "PMP® Certification",
  description: "Course Duration: 5 Days. Master the gold standard of project management with our intensive exam preparation bootcamp led by senior practitioners.",
  icon: Presentation,
  link: "/TrainingPage"
}, {
  title: "PRINCE2® Foundation",
  description: "Course Duration: 4 Days. Implement the world's most practiced method for project management with structured, outcome-based learning modules.",
  icon: Compass,
  link: "/TrainingPage"
}, {
  title: "PMI-ACP® (Agile)",
  description: "Course Duration: 3 Days. Transition to high-velocity delivery. Deep dive into Scrum, Kanban, and Lean methodologies for modern project environments.",
  icon: TrendingUp,
  link: "/TrainingPage"
}, {
  title: "PM Fundamentals",
  description: "Course Duration: 2 Days. Essential grounding for new managers. Learn the core mechanics of scheduling, risk management, and stakeholder control.",
  icon: ChartBar,
  link: "/TrainingPage"
}, {
  title: "ServiceNow Training",
  description: "Course Duration: 3 Days. Technical deep-dives into ServiceNow implementation, migration strategies, and platform administration for enterprise teams.",
  icon: Search,
  link: "/TrainingPage"
}, {
  title: "Bespoke Corporate",
  description: "Course Duration: Flexible. Tailored curriculum designed for your specific industry challenges, focusing on milestone-based delivery and ROI.",
  icon: ChartLine,
  link: "/TrainingPage"
}];
export default function FinancialMasteryPath() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}
function ServiceCard({
  service
}: {
  service: typeof servicesData[0];
}) {
  return <Card className="group relative h-full overflow-hidden border border-border/40 bg-primary text-primary-foreground transition-all duration-500 hover:shadow-2xl hover:border-chart-2/40 rounded-sm">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-[var(--color-chart-2)] opacity-0 transition-opacity duration-500 group-hover:opacity-10" />
      
      {}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-[radial-gradient(circle_at_50%_0%,rgba(var(--color-chart-2),0.1),transparent_70%)]" />

      <CardHeader className="relative z-10 pt-10 pb-4">
        <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-sm bg-primary-foreground/5 border border-primary-foreground/10 transition-all duration-500 group-hover:scale-105 group-hover:bg-[var(--color-chart-2)] group-hover:text-primary group-hover:border-transparent">
          <service.icon className="h-6 w-6 transition-transform duration-500" />
        </div>
        <CardTitle className="font-sans text-2xl font-bold tracking-tight text-primary-foreground group-hover:text-white">
          {service.title}
        </CardTitle>
      </CardHeader>

      <CardContent className="relative z-10 flex flex-col gap-6 pb-10">
        <CardDescription className="text-primary-foreground/80 text-base font-sans leading-relaxed transition-colors duration-300 group-hover:text-primary-foreground">
          {service.description}
        </CardDescription>

        <div className="mt-auto transform translate-y-2 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
          <Button asChild variant="link" className="p-0 h-auto text-[var(--color-chart-2)] hover:text-white hover:no-underline group/btn">
            <Link to={service.link} className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest">
              Enrol for Next Intake 
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>;
}